"use client";

import styled, { css } from "styled-components";
import Box from "../Box/Box";
import { getVariations } from "../utils";
import { VariableComponent } from "../ComponentProps";

function variableStyle(props: GridProps) {
  let gridTemplateColumns = props.templateColumns;
  if (Number.isInteger(Number(gridTemplateColumns))) {
    gridTemplateColumns = `repeat(${gridTemplateColumns}, 1fr)`;
  }
  return css`
    grid-template-columns: ${gridTemplateColumns};
    gap: ${props.gap};
    ${getVariations(props, variableStyle)}
  `;
}

export type GridProps = VariableComponent<{
  templateColumns?: string;
  gap?: string;
}>;

const Grid = styled(Box)<GridProps>`
  // TODO: This display value overrides display values in variations
  // One workaround is to do variations: { "mq.s": { display: "none !important" } }
  // Perhaps there is a way to handle this internally though
  display: grid;
  ${variableStyle}
`;

export default Grid;
